import { createAsyncThunk } from '@reduxjs/toolkit';
import { vacancyControlService } from './VacancyControl.service';
import { errorHandlerThunk } from '../../App/App.thunk';
import { CreateVacancyDto, UpdateVacancyDto } from './VacancyControl.type';

const THUNK_PREFIX = 'vacancyControl';

export const getVacancyControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getVacancyControlListThunk`,
  async (
    params: { q?: string; page?: number | string; sort?: string },
    thunkAPI,
  ) => {
    try {
      const response = await vacancyControlService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createVacancyControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createVacancyControlThunk`,
  async (vacancy: CreateVacancyDto, thunkAPI) => {
    try {
      const response = await vacancyControlService.create(vacancy);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateVacancyControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateVacancyControlThunk`,
  async (vacancy: UpdateVacancyDto, thunkAPI) => {
    try {
      const response = await vacancyControlService.update(vacancy);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteVacancyControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteVacancyControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await vacancyControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
